import * as yup from 'yup';

export const LoginSchema = yup.object().shape({
  email: yup.string().required('Please enter Email or Username').min(3),
  password: yup.string().required().min(3),
});
